import { useAppStore } from '@store'
import { useMemo } from 'react'

export function useGLBInstance(catalogID: string) {
  // Usar un selector que se suscriba a cambios en el catalogID específico
  // Esto asegura que el componente se re-renderice cuando el GLB se guarda
  const preGLB = useAppStore((s) => (catalogID ? s.sceneGLB.get(catalogID) : undefined))

  const items = useAppStore.use.items()
  const item = Array.from(items.values()).find((item: any) => item.catalogID === catalogID)
  const morphs = (item as any)?.morphs || []

  const clonedGLB = useMemo(() => {
    if (!preGLB || !preGLB.glb) {
      return null
    }

    const cloned = (preGLB as any)?.glb?.scene?.clone()
    if (!cloned) {
      return null
    }

    if (morphs.length > 0) {
      const morphAlto = morphs.find((m: any) => m.name === 'Alto')
      if (morphAlto) {
        const scaleY = (morphAlto.value || morphAlto.default) / morphAlto.default
        cloned.scale.set(1, scaleY, 1)
      }
    }

    cloned.traverse((node: any) => {
      if (node.isMesh && node.material) {
        node.material = node.material.clone()
        if (typeof node.material.color?.set === 'function') {
          node.material.color.set('#ffffff')
        }
      }
    })
    return cloned
  }, [preGLB, catalogID, morphs])

  return clonedGLB
}
